import template from './ticketInsurance.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    insurance: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $mdMedia, dateTimeService, helperService) {
      'ngInject';
      /*
       * Controller model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.contacts = [];
      ctrl.currentOrganization = null;
      ctrl.currentCurrency = null;
      ctrl.organizationCountry = '';
      ctrl.isReady = false;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.currentOrganization = $rootScope.CurrentOrganization;
        ctrl.currentCurrency = $rootScope.CurrentCurrency();
        ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
        ctrl.organizationCountry = helperService.getOrganizationCountry().name;
        ctrl.insurance = ctrl.insurance || {};
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;

        dateTimeService.getSet(
          ctrl,
          ctrl.insurance,
          'premiumStartDate',
          'getSetPremiumStartDate'
        );
        dateTimeService.getSet(ctrl, ctrl.insurance, 'premiumEndDate', 'getSetPremiumEndDate');
        ctrl.isReady = true;
      };

      /*
       * Save insurance
       * --------------------------------------------------------------------------------
       */
      ctrl.saveTicketInsurance = () => ctrl.onFinished({ insurance: ctrl.insurance });

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = function () {
        ctrl.initialize();
      };
    }
  }
};
